import { ExtraConfig } from 'src/types/AiAgentV3';

export const defaultColorsBotV3 = {
    fbw_accent: 'rgba(66, 118, 227, 1)',
    fbw_bg: 'rgba(228, 139, 139, 1)',
    fbw_accent_light: 'rgba(77, 95, 225, 1)',
    fbw_bg_grad_start: 'rgba(189, 190, 243, 1)',
    fbw_accent_dark: 'rgba(51, 88, 196, 1)',
    fbw_bg_grad_end: 'rgba(246, 212, 212, 1)',
    fbw_border: 'rgba(229, 231, 235, 1)',
    fbw_border_color: 'rgba(198, 210, 241, 1)',
    fbw_text: 'rgba(66, 66, 66, 1)',
    fbw_text_muted: 'rgba(85, 85, 85, 1)',
    fbw_bot_text: 'rgba(0, 0, 0, 1)',
    fbw_bot_header_text: 'rgba(0, 0, 0, 1)',
    fbw_bg_bot: 'rgba(243, 244, 246, 1)',
    fbw_bot_icon_header_msg: 'rgba(66, 66, 66, 1)',
    fbw_bot_footer_text: 'rgba(85, 85, 85, 1)',
    fbw_user_text: 'rgba(255, 255, 255, 1)',
    fbw_bg_user: 'rgba(77, 95, 225, 1)',
};

export const defaultSizesBotV3 = {
    fbw_bot_avatar_scale: 100,
    fbw_bot_logo_header_scale: 100,
    fbw_bot_panel_radius: 28,
    fbw_bot_panel_border_size: 4,
    fbw_logo_header_radius: 50,
};

export const formatCss = (extra_config: ExtraConfig | undefined, id: number) => {
    return `
        #sbx-bot-widget-${id} {
    /* Primary/brand */
    --fbw-accent: ${extra_config?.fbw_accent || 'rgba(66, 118, 227, 1)'};
    --fbw-accent-light: ${extra_config?.fbw_accent_light || 'rgba(77, 95, 225, 1)'};
    --fbw-accent-dark: ${extra_config?.fbw_accent_dark || 'rgba(51, 88, 196, 1)'};
    --fbw-bot-icon-header-msg: ${extra_config?.fbw_bot_icon_header_msg || 'rgba(66, 66, 66, 1)'};

    /* Backgrounds */
    --fbw-bg: ${extra_config?.fbw_bg || 'rgba(228, 139, 139, 1)'};
    --fbw-bg-grad-start: ${extra_config?.fbw_bg_grad_start || 'rgba(189, 190, 243, 1)'};
    --fbw-bg-grad-end: ${extra_config?.fbw_bg_grad_end || 'rgba(246, 212, 212, 1)'};
    --fbw-bg-gradient: linear-gradient(180deg, var(--fbw-bg-grad-start) 0%, var(--fbw-bg-grad-end) 100%);
    --fbw-bg-bot: ${extra_config?.fbw_bg_bot || 'rgba(243, 244, 246, 1)'};
    --fbw-bg-user: ${extra_config?.fbw_bg_user || 'rgba(77, 95, 225, 1);'};

    /* Shadows and borders */
    --fbw-panel-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    --fbw-border: ${extra_config?.fbw_border || 'rgba(229, 231, 235, 1)'};
    --fbw-border-color: ${extra_config?.fbw_border_color || 'rgba(198, 210, 241, 1)'};

    /* Text */
    --fbw-text: ${extra_config?.fbw_text || 'rgba(66, 66, 66, 1)'};
    --fbw-text-muted: ${extra_config?.fbw_text_muted || 'rgba(85, 85, 85, 1)'};
    --fbw-bot-text: ${extra_config?.fbw_bot_text || 'rgba(0, 0, 0, 1)'};
    --fbw-bot-header-text: ${extra_config?.fbw_bot_header_text || 'rgba(0, 0, 0, 1)'};
    --fbw-bot-footer-text: ${extra_config?.fbw_bot_footer_text || 'rgba(85, 85, 85, 1)'};
    --fbw-user-text: ${extra_config?.fbw_user_text || 'rgba(255, 255, 255, 1)'};

    /* Status */
    --fbw-success: #16a34a;
    --fbw-danger: #ef4444;

    /* Palette - neutrals */
    --fbw-white: #ffffff;
    --fbw-black: #000000;
    --fbw-gray-50: #f9fafb;
    --fbw-gray-100: #f3f4f6;
    --fbw-gray-200: #e5e7eb;
    --fbw-gray-300: #d1d5db;
    --fbw-gray-400: #9ca3af;
    --fbw-gray-500: #6b7280;
    --fbw-gray-600: #4b5563;
    --fbw-gray-700: #374151;
    --fbw-gray-800: #1f2937;
    --fbw-gray-900: #111827;

    /* System/bot bubble greens */
    --fbw-green-50: #ecfdf5;
    --fbw-green-100: #d1fae5;
    --fbw-green-700: #065f46;

    /* Reds */
    --fbw-red-500: #ef4444;
    --fbw-red-700: #b91c1c;

    /* Blues used in hover/focus utilities */
    --fbw-blue-utility-8: rgba(37, 99, 235, 0.08);
    --fbw-blue-utility-15: rgba(37, 99, 235, 0.15);

    /* Whites with alpha */
    --fbw-white-12: rgba(255, 255, 255, 0.12);

    /* link colors */
    --fbw-link-color: #ffffff;

    /* Sizes */
    --fbw-bot-avatar-scale: ${validateSize(extra_config?.fbw_bot_avatar_scale, '100')}%;
    --fbw-bot-logo-header-scale: ${validateSize(extra_config?.fbw_bot_logo_header_scale, '100')}%;
    --fbw-bot-panel-radius: ${validateSize(extra_config?.fbw_bot_panel_radius, '28')}px;
    --fbw-bot-panel-border-size: ${validateSize(extra_config?.fbw_bot_panel_border_size, '4')}px;
    --fbw-logo-header-radius: ${validateSize(extra_config?.fbw_logo_header_radius, '50')}%;
}
    `;
};

function validateSize(val: string | undefined, valAlt: string) {
    if (val === null) return valAlt;
    const num = Number(val);
    if (isNaN(num)) return valAlt;
    return num;
}
